import { Mascot } from './Mascot';
import './Login.css';

export function Login() {
  return (
    <div className="login">
      <div className="login-card">
        <div className="login-logo">
          <Mascot expression="idle" size={56} />
        </div>
        <h1>BK Jira Agent</h1>
        <p>Tu asistente conversacional para crear tickets en Jira con specs técnicas automáticas.</p>

        <div className="login-features">
          <div className="login-feature">
            <span className="login-feature-icon">💬</span>
            <span>Conversa en lenguaje natural</span>
          </div>
          <div className="login-feature">
            <span className="login-feature-icon">📝</span>
            <span>Tickets bien formados en Jira</span>
          </div>
          <div className="login-feature">
            <span className="login-feature-icon">📎</span>
            <span>Spec.md adjunto automáticamente</span>
          </div>
        </div>

        <a href="/auth/login" className="login-button">
          <span>🔐</span>
          Iniciar sesión con Jira
        </a>

        <div className="login-footer">BK Servicios Financieros</div>
      </div>
    </div>
  );
}
